<template>
  <div class="page-container" :class="{ dark: isDarkMode }">
    <ModalLoading :isLoading="cargando" />
    <div class="page-header">
      <div>
      </div>
      <button v-if="puedeCrearCotizacion" class="btn-primary" @click="abrirNueva"><i class="bi bi-plus"></i> Nueva Cotización</button>
    </div>

    <div v-if="esCajero" class="cajero-banner">
      <i class="bi bi-info-circle"></i> Mostrando cotizaciones aprobadas listas para facturar.
    </div>

    <div class="filters-row">
      <input v-model="busqueda" type="text" placeholder="Buscar por N° o cliente..." class="form-input" />
      <select v-model="filtroEstado" class="form-select">
        <option value="">Todos los estados</option>
        <option>Pendiente</option>
        <option>Aceptada</option>
        <option>Rechazada</option>
        <option>Vencida</option>
        <option>Facturada</option>
      </select>
      <select v-if="esCeo" v-model="filtroSucursal" class="form-select" @change="cargar">
        <option value="">Todas las sucursales</option>
        <option v-for="s in sucursalesCeo" :key="s.id_sucursal" :value="s.id_sucursal">
          {{ s.nombre_administrativo }}
        </option>
      </select>
    </div>

    <div v-if="!cotizacionesFiltradas.length" class="empty-state">
      <i class="bi bi-file-earmark"></i>
      <p v-if="esCajero && filtroEstado === 'Aceptada'">No hay cotizaciones aprobadas pendientes de facturar.</p>
      <p v-else>No hay cotizaciones. <span v-if="!esCajero">Crea la primera.</span></p>
    </div>

    <div v-else class="table-container">
    <table class="data-table">
      <thead>
        <tr>
          <th>N° Cotización</th>
          <th>Cliente</th>
          <th>Total</th>
          <th>Válida hasta</th>
          <th>Estado</th>
          <th>Fecha</th>
          <th>Acciones</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="c in cotizacionesPaginadas" :key="c.id_cotizacion">
          <td class="mono">{{ c.numero_cotizacion }}</td>
          <td>{{ c.Clientes?.nombre_completo || 'Sin cliente' }}</td>
          <td>L. {{ fmtNum(c.total) }}</td>
          <td :class="{ 'text-danger': estaVencida(c.fecha_validez) }">
            {{ c.fecha_validez ? fmtFecha(c.fecha_validez) : '—' }}
          </td>
          <td><span :class="estadoClass(c.estado)">{{ c.estado }}</span></td>
          <td>{{ fmtFecha(c.created_at) }}</td>
          <td class="actions">
            <button class="accion-btn accion-azul" @click="verDetalle(c)" title="Ver detalle"><i class="bi bi-eye"></i></button>
            <button v-if="puedeGestionarCotizacion && c.estado === 'Pendiente'" class="accion-btn accion-verde" @click="cambiarEstado(c, 'Aceptada')" title="Aceptar">
              <i class="bi bi-check-lg"></i>
            </button>
            <button v-if="puedeGestionarCotizacion && c.estado === 'Pendiente'" class="accion-btn accion-rojo" @click="cambiarEstado(c, 'Rechazada')" title="Rechazar">
              <i class="bi bi-x-lg"></i>
            </button>
            <button v-if="esCajero && c.estado === 'Aceptada'" class="accion-btn accion-verde" @click="facturarCotizacion(c)"
              :disabled="facturando === c.id_cotizacion" title="Facturar esta cotización">
              <i :class="facturando === c.id_cotizacion ? 'bi bi-hourglass-split' : 'bi bi-cart-check-fill'"></i>
            </button>
            <button class="accion-btn accion-verde" @click="descargarPDF(c)" title="Descargar PDF" :disabled="descargando === c.id_cotizacion">
              <i :class="descargando === c.id_cotizacion ? 'bi bi-hourglass-split' : 'bi bi-file-earmark-pdf'"></i>
            </button>
          </td>
        </tr>
      </tbody>
    </table>

    <!-- Paginación -->
    <div class="pagination-wrapper">
      <div class="pagination-info">
        Mostrando {{ (paginaActual - 1) * porPagina + 1 }} a
        {{ Math.min(paginaActual * porPagina, cotizacionesFiltradas.length) }}
        de {{ cotizacionesFiltradas.length }} registros
      </div>
      <div class="pagination-container">
        <button class="pagination-button" :disabled="paginaActual === 1" @click="previousPage">
          Anterior
        </button>
        <button class="pagination-button" :disabled="paginaActual === totalPaginas" @click="nextPage">
          Siguiente
        </button>
      </div>
    </div>
    </div>

    <!-- Modal nueva cotización -->
    <div v-if="modalNueva" class="modal-overlay">
      <div class="modal-large">
        <div class="modal-header">
          <h2>Nueva Cotización</h2>
          <button class="btn-close-x" @click="modalNueva = false"><i class="bi bi-x-lg"></i></button>
        </div>
        <div class="modal-body">
          <div class="form-row">
            <div class="form-group">
              <label>Cliente (opcional)</label>
              <input
                v-model="clienteBusqueda"
                list="lista-clientes"
                type="text"
                class="form-input"
                placeholder="Buscar cliente por nombre..."
                autocomplete="off"
                @change="onClienteSeleccionado"
                @input="onClienteInput"
              />
              <datalist id="lista-clientes">
                <option v-for="cl in clientesActivos" :key="cl.id_cliente" :value="cl.nombre_completo" />
              </datalist>
            </div>
            <div class="form-group">
              <label>Válida hasta</label>
              <input v-model="form.fecha_validez" type="date" class="form-input" :min="today" />
            </div>
          </div>

          <div class="items-section">
            <h3>Productos</h3>
            <div class="add-item-row">
              <input v-model="itemBusqueda" type="text" :placeholder="cargandoProductos ? 'Cargando productos...' : 'Buscar producto por nombre o código...'" class="form-input flex1" @input="buscarProductos" :disabled="cargandoProductos" />
              <div v-if="productosSugeridos.length" class="sugerencias">
                <div v-for="p in productosSugeridos" :key="p.id_producto" class="sugerencia-item" @click="agregarProducto(p)">
                  {{ p.nombre }} — L.{{ fmtNum(p.precio_unitario) }}
                </div>
              </div>
            </div>
            <table class="items-table" v-if="form.items.length">
              <thead><tr><th>Producto</th><th>Cant.</th><th>Precio</th><th>Desc.</th><th>Subtotal</th><th></th></tr></thead>
              <tbody>
                <tr v-for="(item, i) in form.items" :key="i">
                  <td>{{ item.nombre_producto }}</td>
                  <td><input v-model.number="item.cantidad" type="number" min="1" class="input-sm" @input="calcularTotales" /></td>
                  <td><input v-model.number="item.precio_unitario" type="number" min="0.01" step="0.01" class="input-sm" @input="calcularTotales" /></td>
                  <td><input v-model.number="item.descuento_item" type="number" min="0" step="0.01" class="input-sm" @input="calcularTotales" /></td>
                  <td>L.{{ fmtNum(item.cantidad * item.precio_unitario - (item.descuento_item||0)) }}</td>
                  <td><button class="btn-del" @click="form.items.splice(i,1); calcularTotales()"><i class="bi bi-trash"></i></button></td>
                </tr>
              </tbody>
            </table>
          </div>

          <div class="form-group">
            <label>Notas</label>
            <textarea v-model="form.notas" class="form-textarea" rows="2"></textarea>
          </div>

          <div class="totales-row">
            <span>Subtotal: <strong>L.{{ fmtNum(totales.subtotal) }}</strong></span>
            <span>Desc.: <strong>L.{{ fmtNum(totales.descuento) }}</strong></span>
            <span class="total-grande">Total: <strong>L.{{ fmtNum(totales.total) }}</strong></span>
          </div>
        </div>
        <div class="modal-footer">
          <button class="btn-cancel" @click="modalNueva = false">Cancelar</button>
          <button class="btn-guardar" @click="guardarCotizacion" :disabled="guardando || !form.items.length">
            {{ guardando ? 'Guardando...' : 'Crear Cotización' }}
          </button>
        </div>
      </div>
    </div>

    <!-- Modal detalle -->
    <div v-if="modalDetalle && detalleActivo" class="modal-overlay">
      <div class="modal-large">
        <div class="modal-header">
          <h2>{{ detalleActivo.numero_cotizacion }}</h2>
          <button class="btn-close-x" @click="modalDetalle = false"><i class="bi bi-x-lg"></i></button>
        </div>
        <div class="modal-body">
          <div class="info-row">
            <span>Cliente: <strong>{{ detalleActivo.Clientes?.nombre_completo || 'Consumidor Final' }}</strong></span>
            <span>Válida hasta: <strong>{{ detalleActivo.fecha_validez ? fmtFecha(detalleActivo.fecha_validez) : '—' }}</strong></span>
            <span>Estado: <strong><span :class="estadoClass(detalleActivo.estado)">{{ detalleActivo.estado }}</span></strong></span>
          </div>
          <table class="items-table">
            <thead><tr><th>Producto</th><th>Cant.</th><th>Precio</th><th>Desc.</th><th>Total</th></tr></thead>
            <tbody>
              <tr v-for="d in detalleActivo.detalle_cotizaciones" :key="d.id_detalle_cotizacion">
                <td>{{ d.nombre_producto }}</td>
                <td>{{ d.cantidad }}</td>
                <td>L.{{ fmtNum(d.precio_unitario) }}</td>
                <td>L.{{ fmtNum(d.descuento_item) }}</td>
                <td>L.{{ fmtNum(d.total_item) }}</td>
              </tr>
            </tbody>
          </table>
          <div class="totales-row">
            <span>Subtotal: <strong>L.{{ fmtNum(detalleActivo.subtotal) }}</strong></span>
            <span>Desc.: <strong>L.{{ fmtNum(detalleActivo.descuento) }}</strong></span>
            <span class="total-grande">Total: <strong>L.{{ fmtNum(detalleActivo.total) }}</strong></span>
          </div>
          <div v-if="detalleActivo.notas" class="notas-box"><strong>Notas:</strong> {{ detalleActivo.notas }}</div>
        </div>
      </div>
    </div>

    <ConfirmModal
      :visible="confirmModal.visible"
      :titulo="confirmModal.titulo"
      :mensaje="confirmModal.mensaje"
      :tipo="confirmModal.tipo"
      @confirm="ejecutarConfirm"
      @cancel="confirmModal.visible = false"
    />
  </div>
</template>

<script>
import {
  crearCotizacion, getDetalleCotizacion, actualizarEstadoCotizacion,
  descargarPDFCotizacion
} from '../../services/featuresSolicitudes.js';
import solicitudes from '../../services/solicitudes.js';
import { hasAccionPermiso } from '../../services/permisos.js';
import { useToast } from 'vue-toastification';
import ConfirmModal from '../components/ConfirmModal.vue';
import ModalLoading from "@/components/ModalLoading.vue";
import { setPageTitle } from '@/components/pageMetadata';
const { getSocket } = require('@/services/socket');

export default {
  name: 'CotizacionesPage',
  components: { ConfirmModal, ModalLoading },
  setup() {
    const toast = useToast();
    return { toast };
  },
  data() {
    const token = localStorage.getItem('auth');
    const payload = token ? JSON.parse(atob(token.split('.')[1])) : {};
    const id_usuario = payload.id_usuario || null;
    const rol = Number(localStorage.getItem('role') || payload.id_rol || 0);
    const esCajero = rol === 3;
    const esCeo    = rol === 4;
    return {
      descargando: null,
      facturando: null,
      id_usuario,
      esCajero,
      esCeo,
      isDarkMode: localStorage.getItem('isDarkMode') === 'true',
      today: new Date().toISOString().split('T')[0],
      sucursalesCeo: [],
      filtroSucursal: '',
      cotizaciones: [], clientes: [], productos: [],
      cargando: false, guardando: false, cargandoProductos: false,
      busqueda: '', filtroEstado: '',
      modalNueva: false, modalDetalle: false,
      detalleActivo: null,
      itemBusqueda: '', productosSugeridos: [],
      clienteBusqueda: '',
      form: { id_cliente: null, fecha_validez: '', notas: '', items: [] },
      totales: { subtotal: 0, descuento: 0, total: 0 },
      confirmModal: { visible: false, titulo: '', mensaje: '', tipo: 'warning', accion: null },
      paginaActual: 1,
      porPagina: 10,
    };
  },
  computed: {
    puedeCrearCotizacion()    { return hasAccionPermiso('cotizaciones_crear'); },
    puedeGestionarCotizacion(){ return hasAccionPermiso('cotizaciones_gestionar'); },
    // Solo clientes activos (estado === true) para el datalist
    clientesActivos() {
      return this.clientes.filter(c => c.estado === true || c.estado === 1 || c.estado === 'true');
    },
    cotizacionesFiltradas() {
      return this.cotizaciones.filter(c => {
        if (this.filtroEstado && c.estado !== this.filtroEstado) return false;
        if (this.busqueda) {
          const b = this.busqueda.toLowerCase();
          return c.numero_cotizacion?.toLowerCase().includes(b) ||
            c.Clientes?.nombre_completo?.toLowerCase().includes(b);
        }
        return true;
      });
    },
    totalPaginas() {
      return Math.ceil(this.cotizacionesFiltradas.length / this.porPagina);
    },
    cotizacionesPaginadas() {
      const inicio = (this.paginaActual - 1) * this.porPagina;
      return this.cotizacionesFiltradas.slice(inicio, inicio + this.porPagina);
    }
  },
  watch: {
    busqueda()     { this.paginaActual = 1; },
    filtroEstado() { this.paginaActual = 1; },
  },
  async mounted() {
    setPageTitle('Cotizaciones');
    this._darkListener = () => { this.isDarkMode = localStorage.getItem('isDarkMode') === 'true'; };
    window.addEventListener('poswave:toggle-dark', this._darkListener);
    if (this.esCeo) {
      try {
        this.sucursalesCeo = await solicitudes.fetchRegistrosAuth(`/sucursales/info-summ/${this.id_usuario}`);
        if (!Array.isArray(this.sucursalesCeo)) this.sucursalesCeo = [];
      } catch (e) { this.sucursalesCeo = []; }
    }
    await this.cargar();
    const _s = getSocket();
    if (_s) { this._wsRefresh = () => this.cargar(); _s.on('cotizaciones:refresh', this._wsRefresh); }
  },
  beforeUnmount() {
    window.removeEventListener('poswave:toggle-dark', this._darkListener);
    const _s = getSocket();
    if (_s && this._wsRefresh) _s.off('cotizaciones:refresh', this._wsRefresh);
  },
  methods: {
    mostrarConfirm(titulo, mensaje, accion, tipo = 'warning') {
      this.confirmModal = { visible: true, titulo, mensaje, tipo, accion };
    },
    ejecutarConfirm() {
      this.confirmModal.visible = false;
      if (this.confirmModal.accion) this.confirmModal.accion();
    },
    async cargar() {
      this.cargando = true;
      try {
        const url = this.esCeo && this.filtroSucursal
          ? `/cotizaciones/${this.id_usuario}?sucursal=${this.filtroSucursal}`
          : `/cotizaciones/${this.id_usuario}`;
        [this.cotizaciones, this.clientes] = await Promise.all([
          solicitudes.fetchRegistrosAuth(url),
          solicitudes.fetchRegistrosAuth(`/clientes/${this.id_usuario}`)
        ]);
      } catch (e) { console.error(e); } finally { this.cargando = false; }
    },
    onClienteSeleccionado() {
      // Al seleccionar del datalist, buscar el id_cliente por nombre
      const match = this.clientesActivos.find(
        c => c.nombre_completo === this.clienteBusqueda
      );
      this.form.id_cliente = match ? match.id_cliente : null;
    },
    onClienteInput() {
      // Si el campo queda vacío, limpiar la selección
      if (!this.clienteBusqueda.trim()) this.form.id_cliente = null;
    },
    async abrirNueva() {
      // Mostrar modal inmediatamente sin esperar la API
      this.clienteBusqueda = '';
      this.form = { id_cliente: null, fecha_validez: '', notas: '', items: [] };
      this.totales = { subtotal: 0, descuento: 0, total: 0 };
      this.modalNueva = true;
      // Cargar productos en paralelo si aún no están cargados
      if (!this.productos.length) {
        this.cargandoProductos = true;
        try { this.productos = await solicitudes.fetchRegistrosAuth(`/productos/${this.id_usuario}`); }
        catch (e) { console.error(e); }
        finally { this.cargandoProductos = false; }
      }
    },
    buscarProductos() {
      if (!this.itemBusqueda.trim()) { this.productosSugeridos = []; return; }
      const b = this.itemBusqueda.toLowerCase();
      this.productosSugeridos = this.productos.filter(p =>
        p.nombre?.toLowerCase().includes(b) || p.codigo_producto?.toLowerCase().includes(b)
      ).slice(0, 8);
    },
    agregarProducto(p) {
      this.form.items.push({
        id_producto: p.id_producto,
        nombre_producto: p.nombre,
        cantidad: 1,
        precio_unitario: parseFloat(p.precio_unitario || 0),
        descuento_item: 0
      });
      this.itemBusqueda = '';
      this.productosSugeridos = [];
      this.calcularTotales();
    },
    calcularTotales() {
      const sub = this.form.items.reduce((s, i) => s + i.cantidad * i.precio_unitario, 0);
      const desc = this.form.items.reduce((s, i) => s + (i.descuento_item || 0), 0);
      this.totales = { subtotal: sub, descuento: desc, total: sub - desc };
    },
    async guardarCotizacion() {
      if (!this.form.id_cliente) {
        this.toast.warning('El cliente es obligatorio en la cotización.');
        return;
      }
      if (!this.form.items.length) {
        this.toast.warning('Agrega al menos un producto.');
        return;
      }
      for (const item of this.form.items) {
        if (!item.precio_unitario || item.precio_unitario <= 0) {
          this.toast.warning(`El precio de "${item.nombre_producto}" debe ser mayor a 0.`);
          return;
        }
        const descMax = item.cantidad * item.precio_unitario;
        if ((item.descuento_item || 0) > descMax) {
          this.toast.warning(`El descuento de "${item.nombre_producto}" supera el subtotal del ítem.`);
          return;
        }
      }
      this.guardando = true;
      try {
        await crearCotizacion(this.id_usuario, this.form);
        this.modalNueva = false;
        await this.cargar();
      } catch (e) { this.toast.error('Error: ' + e.message); } finally { this.guardando = false; }
    },
    async verDetalle(c) {
      try {
        this.detalleActivo = await getDetalleCotizacion(c.id_cotizacion);
        this.modalDetalle = true;
      } catch (e) { this.toast.error('Error: ' + e.message); }
    },
    async cambiarEstado(c, estado) {
      this.mostrarConfirm(
        'Cambiar estado',
        `¿Cambiar estado de la cotización ${c.numero_cotizacion} a "${estado}"?`,
        async () => {
          try {
            await actualizarEstadoCotizacion(c.id_cotizacion, estado);
            await this.cargar();
          } catch (e) { this.toast.error('Error: ' + e.message); }
        }
      );
    },
    async facturarCotizacion(c) {
      this.facturando = c.id_cotizacion;
      try {
        const detalle = await getDetalleCotizacion(c.id_cotizacion);
        if (detalle.estado !== 'Aceptada') {
          this.toast.warning(`La cotización ya no está en estado Aceptada (estado actual: ${detalle.estado}).`);
          await this.cargar();
          return;
        }
        const items = (detalle.detalle_cotizaciones || []).map(i => ({
          codigo_producto: i.Productos?.codigo_producto || i.id_producto,
          cantidad: i.cantidad,
          nombre_producto: i.nombre_producto,
          precio_unitario: i.precio_unitario
        })).filter(i => i.codigo_producto);

        if (!items.length) {
          this.toast.warning('Esta cotización no tiene productos con código válido.');
          return;
        }

        localStorage.setItem('cotizacion_pendiente', JSON.stringify({
          id_cotizacion: c.id_cotizacion,
          numero_cotizacion: c.numero_cotizacion,
          id_cliente: detalle.id_cliente,
          items
        }));
        this.$router.push('/ventas');
      } catch (e) {
        this.toast.error('Error al cargar cotización: ' + e.message);
      } finally {
        this.facturando = null;
      }
    },
    async descargarPDF(c) {
      this.descargando = c.id_cotizacion;
      try {
        await descargarPDFCotizacion(c.id_cotizacion);
        this.toast.success(`PDF descargado: ${c.numero_cotizacion}`);
      } catch (e) { this.toast.error('Error al generar PDF: ' + e.message); }
      finally { this.descargando = null; }
    },
    previousPage() {
      if (this.paginaActual > 1) this.paginaActual--;
    },
    nextPage() {
      if (this.paginaActual < this.totalPaginas) this.paginaActual++;
    },
    estaVencida(f) { return f && new Date(f) < new Date(); },
    fmtNum(n) { return Number(n || 0).toLocaleString('es-HN', { minimumFractionDigits: 2 }); },
    fmtFecha(f) { return new Date(f).toLocaleDateString('es-HN'); },
    estadoClass(e) {
      return {
        'badge-info':      e === 'Pendiente',
        'badge-success':   e === 'Aceptada',
        'badge-danger':    e === 'Rechazada' || e === 'Vencida',
        'badge-facturada': e === 'Facturada',
      };
    }
  }
};
</script>

<style scoped>
@import url("https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,100..900;1,100..900&display=swap");

* { font-family: "Montserrat", sans-serif; box-sizing: border-box; }

/* ── Page Layout ── */
.page-container { padding: 16px; width: 100%; overflow-x: hidden; background: #ffffff; min-height: 100vh; color: #212529; }
.page-header { display: flex; align-items: center; justify-content: space-between; flex-wrap: wrap; gap: 16px; margin-bottom: 20px; padding: 0 4px; }
.page-header h1 { font-size: clamp(22px, 4vw, 30px); font-weight: 700; margin: 8px 0; color: #333; }
.subtitle { font-size: 0.875rem; color: #6c757d; margin: 0; }
.opciones { display: flex; align-items: center; flex-wrap: wrap; gap: 12px; margin-bottom: 16px; }

/* ── Inputs ── */
.busqueda, .form-input { padding: 8px 12px; font-size: 14px; border-radius: 10px; border: 1px solid #ced4da; outline: none; background: white; color: #212529; transition: all 0.3s ease; }
input:focus, select:focus, textarea:focus { border-color: #c09d62; box-shadow: 0 0 0 3px rgba(192,157,98,0.2); outline: none; }
.form-select, select { padding: 8px 12px; border-radius: 10px; border: 1px solid #ced4da; font-family: "Montserrat", sans-serif; font-size: 14px; cursor: pointer; background: white; color: #212529; }
.form-textarea { width: 100%; padding: 8px 12px; border-radius: 10px; border: 1px solid #ced4da; font-family: "Montserrat", sans-serif; font-size: 14px; resize: vertical; outline: none; background: white; color: #212529; }

/* ── Buttons ── */
.btn-primary { background-color: #c09d62; color: white; padding: 8px 16px; border: none; border-radius: 10px; font-size: 14px; font-weight: 600; cursor: pointer; display: inline-flex; align-items: center; gap: 6px; transition: all 0.3s ease; font-family: "Montserrat", sans-serif; }
.btn-primary:hover { background-color: #a38655; transform: scale(1.02); }
.btn-primary:disabled { opacity: 0.5; cursor: not-allowed; transform: none; }
/* Guardar/confirmar = verde */
.btn-guardar { background-color: #198754; color: white; padding: 8px 16px; border: none; border-radius: 10px; font-size: 14px; font-weight: 600; cursor: pointer; display: inline-flex; align-items: center; gap: 6px; transition: all 0.3s ease; font-family: "Montserrat", sans-serif; }
.btn-guardar:hover:not(:disabled) { background-color: #146c43; transform: scale(1.02); }
.btn-guardar:disabled { opacity: 0.5; cursor: not-allowed; transform: none; }
.btn-cancel, .btn-secondary { background-color: #6c757d; color: white; padding: 8px 16px; border: none; border-radius: 10px; font-size: 14px; font-weight: 600; cursor: pointer; display: inline-flex; align-items: center; gap: 6px; transition: all 0.3s ease; font-family: "Montserrat", sans-serif; }
.btn-cancel:hover, .btn-secondary:hover { background-color: #5a6268; }
.btn-danger { background-color: #dc3545; color: white; padding: 8px 16px; border: none; border-radius: 10px; font-size: 14px; font-weight: 600; cursor: pointer; display: inline-flex; align-items: center; gap: 6px; transition: all 0.3s ease; }
.btn-danger:hover { background-color: #b02a37; }
/* Botones de acción — nombres únicos para no chocar con design-system.css */
.accion-btn {
  width: 35px;
  height: 35px;
  font-size: 16px;
  border-radius: 10px;
  color: white;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  border: none;
  cursor: pointer;
  transition: all 0.3s ease;
}
.accion-btn:hover:not(:disabled) { transform: scale(1.05); }
.accion-btn:disabled { opacity: 0.5; cursor: not-allowed; transform: none; }
.accion-azul  { background-color: #0d6efd; }
.accion-azul:hover  { background-color: #0056b3; }
.accion-verde { background-color: #198754; }
.accion-verde:hover:not(:disabled) { background-color: #146c43; }
.accion-rojo  { background-color: #dc3545; }
.accion-rojo:hover  { background-color: #bb2d3b; }
.btn-close-x { background: none; border: none; cursor: pointer; font-size: 1rem; color: #6c757d; padding: 4px; border-radius: 6px; display: flex; align-items: center; }
.btn-close-x:hover { color: #212529; background: #f8f9fa; }

/* ── Loading / Empty ── */
.loading { display: flex; justify-content: center; padding: 3rem; }
.spinner { width: 36px; height: 36px; border: 3px solid #f3f3f3; border-top: 3px solid #c09d62; border-radius: 50%; animation: spin 0.8s linear infinite; }
@keyframes spin { to { transform: rotate(360deg); } }
.empty-state { display: flex; flex-direction: column; align-items: center; padding: 3rem; gap: 12px; color: #6c757d; text-align: center; }
.empty-state i { font-size: 2.5rem; opacity: 0.4; }

/* ── Table ── */
.table-container { width: 100%; overflow-x: auto; -webkit-overflow-scrolling: touch; margin-bottom: 20px; border-radius: 8px; border: 1px solid #e2e8f0; }
.table-container::-webkit-scrollbar { width: 8px; height: 8px; }
.table-container::-webkit-scrollbar-track { background: #f1f1f1; border-radius: 4px; }
.table-container::-webkit-scrollbar-thumb { background: #c09d62; border-radius: 4px; }
.table-container::-webkit-scrollbar-thumb:hover { background: #a38655; }
.data-table, .table { width: 100%; border-collapse: collapse; font-size: 0.875rem; }
.data-table th, .table th { padding: 8px 12px; text-align: left; font-weight: 700; font-size: 0.8rem; border-bottom: 2px solid #dee2e6; background: #f8f9fa; position: sticky; top: 0; z-index: 1; white-space: nowrap; color: #495057; }
.data-table td, .table td { padding: 8px 12px; border-bottom: 1px solid #dee2e6; vertical-align: middle; color: #212529; background: white; }
.data-table tbody tr:last-child td, .table tbody tr:last-child td { border-bottom: none; }
.data-table tbody tr:hover td, .table tbody tr:hover td { background-color: #f8f9fa; }

/* ── Texto ── */
.text-danger { color: #dc3545 !important; }
.text-warning { color: #856404 !important; }
.text-success { color: #0f5132 !important; }
.text-muted { color: #6c757d; }

/* ── Badges ── */
.estado-badge, .badge { padding: 3px 8px; font-size: 0.75rem; border-radius: 12px; font-weight: 600; display: inline-block; }
.estado-pendiente, .badge-info, .badge-pendiente { background-color: #fff3cd; color: #856404; }
.estado-pagado, .badge-success, .badge-pagado { background-color: #d1e7dd; color: #0f5132; }
.estado-parcial, .badge-parcial { background-color: #d1ecf1; color: #0c5460; }
.badge-danger, .estado-rechazado, .badge-rechazado, .estado-vencido { background-color: #f8d7da; color: #842029; }
.badge-facturada, .estado-facturada, .badge-facturado { background-color: #e2e8f0; color: #495057; }

/* ── Acciones ── */
/* Columna Acciones — ancho fijo para 4 botones de 35px + gap 6px = 158px mínimo */
.data-table th:last-child,
.data-table td:last-child {
  width: 170px;
  min-width: 170px;
  text-align: center !important;
}
.actions-column, .actions {
  display: flex;
  gap: 6px;
  justify-content: center;
  align-items: center;
  white-space: nowrap;
}

/* ── Modal ── */
.modal-overlay { position: fixed; inset: 0; background: rgba(0,0,0,0.5); display: flex; align-items: center; justify-content: center; z-index: 9000; padding: 1rem; }
.modal-box, .modal-content, .modal-large { background: white; border-radius: 12px; box-shadow: 0 8px 32px rgba(0,0,0,0.2); width: 100%; max-width: 600px; max-height: 90vh; display: flex; flex-direction: column; overflow: hidden; }
.modal-large { max-width: 750px; }
.modal-header { display: flex; align-items: center; justify-content: space-between; padding: 1rem 1.25rem; border-bottom: 1px solid #dee2e6; background: #f8f9fa; }
.modal-header h2, .modal-header h3 { font-size: 1rem; font-weight: 700; margin: 0; color: #212529; }
.modal-body { padding: 1.25rem; overflow-y: auto; flex: 1; background: white; }
.modal-footer { padding: 1rem 1.25rem; border-top: 1px solid #dee2e6; display: flex; gap: 8px; justify-content: flex-end; background: #f8f9fa; }

/* ── Forms ── */
.form-row { display: grid; grid-template-columns: 1fr 1fr; gap: 12px; margin-bottom: 12px; }
.form-group { display: flex; flex-direction: column; gap: 4px; margin-bottom: 12px; }
.form-group label { font-size: 0.8rem; font-weight: 600; color: #495057; }
.form-group .form-input, .form-group .form-select, .form-group textarea { width: 100%; }

/* ── Pagination ── */
.pagination-wrapper { display: flex; justify-content: space-between; align-items: center; padding: 1rem; border-top: 1px solid #dee2e6; }
.pagination-info { color: #6c757d; font-size: 0.875rem; }
.pagination-container { display: flex; gap: 5px; }
.pagination-button { padding: 6px 14px; border: 1px solid #dee2e6; background: white; cursor: pointer; border-radius: 6px; font-size: 0.875rem; font-family: "Montserrat", sans-serif; transition: all 0.3s ease; }
.pagination-button:hover, .pagination-button.active { background: #c09d62; color: white; border-color: #c09d62; }
.pagination-button:disabled { opacity: 0.5; cursor: not-allowed; }

/* ── Cajero banner ── */
.cajero-banner {
  background: #e8f4fd; border: 1px solid #bee3f8; border-radius: 8px;
  padding: 10px 14px; margin-bottom: 14px; color: #2c5282;
  font-size: 0.875rem; display: flex; align-items: center; gap: 8px;
}

/* ── Filters row ── */
.filters-row { display: flex; flex-wrap: wrap; gap: 10px; margin-bottom: 16px; align-items: center; }
.filters-row .form-input { flex: 1; min-width: 180px; }
.filters-row .form-select { min-width: 160px; }
.flex1 { flex: 1; }

/* ── Monospace (N° cotización) ── */
.mono { font-family: "Courier New", monospace; font-size: 0.8rem; color: #495057; letter-spacing: 0.03em; }


/* ── Items section inside modal ── */
.items-section { margin-bottom: 12px; }
.items-section h3 { font-size: 0.9rem; font-weight: 700; color: #212529; margin: 0 0 8px; }

/* ── Add item row (search + suggestions) ── */
.add-item-row { position: relative; margin-bottom: 10px; display: flex; }
.add-item-row .form-input { flex: 1; width: 100%; }

/* ── Product suggestions dropdown ── */
.sugerencias {
  position: absolute; top: 100%; left: 0; right: 0; z-index: 100;
  background: white; border: 1px solid #dee2e6; border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0,0,0,0.1); max-height: 220px; overflow-y: auto;
}
.sugerencia-item {
  padding: 8px 12px; cursor: pointer; font-size: 0.875rem; color: #212529;
  border-bottom: 1px solid #f0f0f0; transition: background 0.15s;
}
.sugerencia-item:last-child { border-bottom: none; }
.sugerencia-item:hover { background: #fffaf2; color: #c09d62; }

/* ── Items table (inside modal) ── */
.items-table { width: 100%; border-collapse: collapse; font-size: 0.85rem; margin-bottom: 10px; }
.items-table th {
  padding: 6px 10px; background: #f8f9fa; border-bottom: 2px solid #dee2e6;
  font-weight: 700; color: #495057; text-align: left; font-size: 0.78rem;
}
.items-table td { padding: 6px 10px; border-bottom: 1px solid #f0f0f0; vertical-align: middle; color: #212529; }
.items-table tbody tr:last-child td { border-bottom: none; }

/* ── Small inline inputs ── */
.input-sm {
  width: 80px; padding: 4px 8px; font-size: 0.8rem;
  border: 1px solid #ced4da; border-radius: 6px;
  text-align: right; outline: none;
  font-family: "Montserrat", sans-serif; color: #212529; background: white;
}
.input-sm:focus { border-color: #c09d62; box-shadow: 0 0 0 2px rgba(192,157,98,0.15); }

/* ── Delete button in items table ── */
.btn-del {
  width: 28px; height: 28px; border-radius: 6px; border: 1px solid #f1aeb5;
  background: #f8d7da; color: #842029; cursor: pointer; font-size: 13px;
  display: inline-flex; align-items: center; justify-content: center; transition: all 0.2s;
}
.btn-del:hover { background: #842029; color: white; }

/* ── Totals row ── */
.totales-row {
  display: flex; flex-wrap: wrap; gap: 16px; align-items: center;
  padding: 10px 14px; background: #f8f9fa; border-radius: 8px;
  border: 1px solid #dee2e6; margin-top: 8px;
  font-size: 0.875rem; color: #495057;
}
.total-grande { font-size: 1rem; font-weight: 700; color: #212529; margin-left: auto; }
.total-grande strong { color: #c09d62; }

/* ── Info row in detail modal ── */
.info-row {
  display: flex; flex-wrap: wrap; gap: 16px;
  background: #f8f9fa; border-radius: 8px; border: 1px solid #dee2e6;
  padding: 10px 14px; margin-bottom: 14px; font-size: 0.875rem; color: #495057;
}
.info-row span strong { color: #212529; }

/* ── Notes box ── */
.notas-box {
  margin-top: 12px; padding: 10px 14px; background: #fffaf2;
  border: 1px solid #e9d8b0; border-radius: 8px;
  font-size: 0.875rem; color: #212529; line-height: 1.5;
}

/* ── Input error state ── */
.input-error { border-color: #dc3545 !important; box-shadow: 0 0 0 2px rgba(220,53,69,0.15) !important; }

@media (max-width: 640px) {
  .form-row { grid-template-columns: 1fr; }
  .page-header { flex-direction: column; }
  .filters-row { flex-direction: column; }
  .totales-row { flex-direction: column; gap: 6px; }
  .total-grande { margin-left: 0; }
  .info-row { flex-direction: column; gap: 6px; }
}

/* ── Dark Mode ── */
.dark .page-container { background: #1e1e1e; color: #e5e5e5; }
.dark .page-header h1 { color: #e5e5e5; }
.dark .subtitle { color: #9e9e9e; }
.dark .form-input, .dark .busqueda { background: #2d2d2d; color: #e5e5e5; border-color: #404040; }
.dark .form-select, .dark select { background: #2d2d2d; color: #e5e5e5; border-color: #404040; }
.dark .form-textarea { background: #2d2d2d; color: #e5e5e5; border-color: #404040; }
.dark .table-container { border-color: #404040; }
.dark .data-table th, .dark .table th { background: #2d2d2d; color: #9e9e9e; border-color: #404040; }
.dark .data-table td, .dark .table td { background: #1e1e1e; color: #e5e5e5; border-color: #404040; }
.dark .data-table tbody tr:hover td, .dark .table tbody tr:hover td { background: #2d2d2d; }
.dark .pagination-wrapper { border-color: #404040; }
.dark .pagination-info { color: #9e9e9e; }
.dark .pagination-button { background: #2d2d2d; color: #e5e5e5; border-color: #404040; }
.dark .pagination-button:hover:not(:disabled), .dark .pagination-button.active { background: #c09d62; color: white; border-color: #c09d62; }
.dark .btn-guardar { background-color: #198754; }
.dark .btn-guardar:hover:not(:disabled) { background-color: #146c43; }
.dark .btn-close-x { color: #9e9e9e; }
.dark .btn-close-x:hover { color: #e5e5e5; background: #3d3d3d; }
.dark .form-group label { color: #9e9e9e; }
.dark .modal-box, .dark .modal-content, .dark .modal-large { background: #1e1e1e; }
.dark .modal-header { background: #2d2d2d; border-color: #404040; }
.dark .modal-header h2, .dark .modal-header h3 { color: #e5e5e5; }
.dark .modal-body { background: #1e1e1e; }
.dark .modal-footer { background: #2d2d2d; border-color: #404040; }
.dark .empty-state { color: #9e9e9e; }
.dark .cajero-banner { background: #1a2f3a; border-color: #2d4a5a; color: #90cdf4; }
.dark .sugerencias { background: #2d2d2d; border-color: #404040; box-shadow: 0 4px 12px rgba(0,0,0,0.4); }
.dark .sugerencia-item { color: #e5e5e5; border-color: #404040; }
.dark .sugerencia-item:hover { background: #3d3d3d; color: #c09d62; }
.dark .items-table th { background: #2d2d2d; color: #9e9e9e; border-color: #404040; }
.dark .items-table td { color: #e5e5e5; border-color: #3d3d3d; }
.dark .input-sm { background: #2d2d2d; color: #e5e5e5; border-color: #404040; }
.dark .totales-row { background: #2d2d2d; border-color: #404040; color: #9e9e9e; }
.dark .total-grande { color: #e5e5e5; }
.dark .info-row { background: #2d2d2d; border-color: #404040; color: #9e9e9e; }
.dark .info-row span strong { color: #e5e5e5; }
.dark .notas-box { background: #2a2215; border-color: #4a3d1a; color: #e5e5e5; }
.dark .items-section h3 { color: #e5e5e5; }
</style>